import { render, staticRenderFns } from "./AnnouncementDetail.vue?vue&type=template&id=31bf38f4&scoped=true&"
import script from "./AnnouncementDetail.vue?vue&type=script&lang=js&"
export * from "./AnnouncementDetail.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementDetail.vue?vue&type=style&index=0&id=31bf38f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bf38f4",
  null
  
)

export default component.exports